import React from 'react';
import {
  renderGroupParentState,
  renderChildRowState,
  renderSingleRowState,
  type StateCellParams
} from './StateCellHelpers';

const StateCell: React.FC<StateCellParams> = (params) => {
  const {
    scheduleItem,
    contract,
    isGroupRow,
    isChildRow,
    isCheckboxDisabled,
    isSelected,
    isExpanded,
    onToggleSelection,
    onToggleExpand,
    onAddToGroup,
    onRemoveFromGroup
  } = params;

  // Group parent row: expand + add buttons
  if (isGroupRow && !isChildRow) {
    return renderGroupParentState(scheduleItem, isCheckboxDisabled, isExpanded, onToggleExpand, onAddToGroup);
  }

  // Child row: remove button + state badge
  if (isChildRow) {
    return renderChildRowState(scheduleItem, contract, isCheckboxDisabled, onRemoveFromGroup);
  }

  // Single row: checkbox + state badge
  return renderSingleRowState(scheduleItem, contract, isCheckboxDisabled, isSelected, onToggleSelection);
};

export default StateCell;
